import moment from 'moment';
import Api from '../Api';
import { parseUnits, formatHash } from '../utils';
import { closeModal } from '../modal';

export function createModalApp(selector, store) {
    let app =  PetiteVue.createApp({
        ticketPrices: [],
        ticketUses: 1,
        customUses: 100,
        store,
        isLoadingPrices: false,
        payWith: 'xec',

        mounted() {
            // this.getTicketPrices();
        },

        async getTicketPrices() {
            console.log('Getting ticket prices');
            this.isLoadingPrices = true;
            try {
                const prices = await Api.ticket.getTicketPrices();
                this.ticketPrices = prices;
            } catch (e) {
                console.error('Failed to get ticket prices', e);
            }
            this.isLoadingPrices = false;
        },

        close() {
            closeModal(selector);
            store.modal = false;
        },

        sendConversion() {
            if (window.gtag) {
                window.gtag('event', 'ads_conversion_party_joined', {});
            }
        },

        get formUses() {
            if (this.ticketUses == 'custom') {
                return this.customUses;
            } else {
                return this.ticketUses;
            }
        },

        get toPay() {
            const price = this.ticketPrices.find(p => p.code == this.payWith);
            let total = 0;
            if (!price) return total;

            if (this.ticketUses == 'custom') {
                total = price.price * this.customUses;
            } else {
                total = price.price * this.ticketUses;
            }

            return Math.round(total * price.mul) / price.mul;
        }
    });
    return app;

    console.log('Modal app', app);
}